export default {
	name: 'news-modal',
	created() {
		this.$store.dispatch('getNotifications');
	},
	mounted() {
		document.documentElement.style.overflow = 'hidden';
		document.body.scroll = 'no';
	},
	data() {
		return {
			backed: false,
			months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
		};
	},
	computed: {
		numberOfNewNotifications() {
			return this.$store.state.user.numberOfNewNotifications;
		},
		isLoading() {
			return this.$store.state.user.isLoadingNotifications;
		},
		notifications() {
			return this.$store.state.user.notifications;
		}
	},
	methods: {
		loadNotifications() {
			if (!this.menu) {
				this.$store.dispatch('getNotifications');
			}
		},
		parseNotificationDate(timestamp) {
			const now = new Date();
			const notificationDate = new Date(timestamp * 1000);
			if (now.getFullYear() === notificationDate.getFullYear() &&
				now.getMonth() === notificationDate.getMonth() &&
				now.getDate() === notificationDate.getDate()) {
				return 'Today';
			}
			const yesterday = new Date()
			yesterday.setDate(yesterday.getDate() - 1);
			if (yesterday.getFullYear() === notificationDate.getFullYear() &&
				yesterday.getMonth() === notificationDate.getMonth() &&
				yesterday.getDate() === notificationDate.getDate()) {
				return 'Yesterday';
			}
			return `${notificationDate.getDate()} ${this.months[ notificationDate.getMonth() ]}`
		},
		back() {
			if (!this.backed) {
				this.backed = true;
				this.$router.go(-1);
			}
		}
	},
	destroyed() {
		document.documentElement.style.overflow = 'auto';
		document.body.scroll = 'yes';
	}
};



// WEBPACK FOOTER //
// ./app/components/news-modal/script.js